import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import useFetch from "utils/hooks/useFetch";
import { useNavigate } from "react-router-dom";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, FormTypeAdd, FormTypeEdit, ModalTypeConfirmation, ModalTypeFail, ModalTypeLoading, ModalTypeSuccess } from "utils/Constant";
import { ApiCreateCompany, ApiGetCompanyById, ApiUpdateCompany } from "utils/constants/api";
import { GetStatus, money, removeNonNumeric } from "utils/helpers";
import { useModal } from "components/modal/ModalContext";
import Select from 'react-select'
import moment from "moment";
import DatePicker from "components/Input/DatePicker";

export default function ClientForm(){
    let navigate = useNavigate()
    const { openModal, closeModal } = useModal()
    
    const { fetch: apiCreateCompany } = useFetch(ApiCreateCompany)
    const { fetch: apiUpdateCompany } = useFetch(ApiUpdateCompany)
    const { fetch: apiGetCompanyById } = useFetch(ApiGetCompanyById)
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let companyId = queryString.get("companyId")
    
    const [companyName, setCompanyName] = useState('')
    const [address, setAddress] = useState('')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('')
    const [locationQuota, setLocationQuota] = useState('')
    const [pricePerLocation, setPricePerLocation] = useState('')
    const [registeredUser, setRegisteredUser] = useState('')
    const [registeredEmployee, setRegisteredEmployee] = useState('')
    
    // Header Info
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')
    
    // Button Event
    const saveBtnClick = () => {
        if(validation()){
            openModal(ModalTypeConfirmation, {
                onConfirm: () => {
                    openModal(ModalTypeLoading)
    
                    if (formType === FormTypeAdd) {
                        createCompany().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/client") 
                                    }
                                })
                            }
                        })
                    } else {
                        updateCompany().then((res) => {
                            if (checkResponse(res)) {
                                openModal(ModalTypeSuccess, {
                                    onSuccess: () => {
                                        closeModal()
                                        navigate("/client") 
                                    }
                                })
                            }
                        })
                    }                    
                }
            })
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }
    
    // API Calls
    const createCompany = async() => {
        let res = await apiCreateCompany({
            data: {
                companyName,
                address,
                phone,
                email,
                locationQuota,
                pricePerLocation: pricePerLocation.replaceAll(',', '')
            }
        })

        return res
    }
    const updateCompany = async() => {
        let res = await apiUpdateCompany({
            data: {
                companyId,
                companyName,
                address,
                phone,
                email,
                locationQuota,
                pricePerLocation: pricePerLocation.replaceAll(',', '')
            }
        })

        return res
    }
    const getCompanyById = async() => {
        let res = await apiGetCompanyById({
            data: {
                companyId
            }
        })

        return res
    }

    // Function
    const validation = () => {
        // if (product === null){
        //     openModal(ModalTypeFail, { message: 'Product is required!' })
        //     return false
        // } else if (product.value === '') {
        //     openModal(ModalTypeFail, { message: 'Product is required!' })
        //     return false
        // }
        // if (stockIn === null) {
        //     openModal(ModalTypeFail, { message: 'Stock In Date is required!' })
        //     return false
        // }
        // if (purchasePrice === '') {
        //     openModal(ModalTypeFail, { message: 'Purchase Price is required!' })
        //     return false
        // }
        // if (rentalPriceHour === '') {
        //     openModal(ModalTypeFail, { message: 'Rental Price / Hour is required!' })
        //     return false
        // }
        // if (rentalPriceDay === '') {
        //     openModal(ModalTypeFail, { message: 'Rental Price / Day is required!' })
        //     return false
        // }
        // if (rentalPriceSession === '') {
        //     openModal(ModalTypeFail, { message: 'Rental Price / Session is required!' })
        //     return false
        // }
        // if (sellingPrice === '') {
        //     openModal(ModalTypeFail, { message: 'Selling Price is required!' })
        //     return false
        // }

        return true
    }
    const checkResponse = (res) => {
        if (res.status === ApiResponseSuccess) {
            return true
        } else if (res.status === ApiResponseStatusUnauthorized) {
            window.location.href = "/login"
            return false
        } else {
            openModal(ModalTypeFail, { message: res.message })
            return false
        }
    }
    
    useEffect(() => {
        if (formType === FormTypeEdit) {
            openModal(ModalTypeLoading)
            getCompanyById().then((res) => {
                if (checkResponse(res)) {
                    let data = res.data
                    setCompanyName(data.companyName)
                    setAddress(data.address)
                    setPhone(data.phone)
                    setEmail(data.email)
                    setLocationQuota(data.locationQuota)
                    setPricePerLocation(money(data.pricePerLocation))
                    setRegisteredUser(data.registeredUser)
                    setRegisteredEmployee(data.registeredEmployee)

                    // Header
                    setStatus(data.status)
                    setCreateBy(data.createBy)
                    setCreateDate(data.createDate)
                    setUpdateBy(data.updateBy)
                    setUpdateDate(data.updateDate)
                    
                    closeModal()
                }
            })
        }
    }, [])

    return(
        <div className="flex p-3 min-h-full w-full">
            <div className="flex flex-col w-full justify-between gap-2 sm:bg-white sm:p-6 sm:rounded-xl sm:shadow-lg min-h-full">
                <div>
                    <div className="flex justify-between">
                        <span className="font-semibold text-2xl">Client Detail</span>
                        <div className={`flex gap-2 items-end justify-end ${ formType === FormTypeAdd ? 'hidden' : 'block'}`}>
                            <span className="text-sm opacity-60">
                                Status : {GetStatus(status)} | Created : {moment(createDate).format("DD MMM yyyy")} | Last Updated : {moment(updateDate).format("DD MMM yyyy")} | By : {updateBy}
                            </span>
                        </div>
                    </div>
                    <hr />

                    <div className="mt-5 flex flex-col gap-3 ">
                        {/* Company Name */}
                        <CardForm title='Company Name'>
                            <input className="input" value={companyName} onChange={(e) => { setCompanyName(e.target.value) }} />
                        </CardForm>

                        {/* Address */}
                        <CardForm title='Address'>
                            <input className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} />
                        </CardForm>

                        {/* Phone */}
                        <CardForm title='Phone'>
                            <input className="input" value={phone} onChange={(e) => { setPhone(e.target.value) }} />
                        </CardForm>

                        {/* Email */}
                        <CardForm title='Email'>
                            <input className="input" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                        </CardForm>

                        {/* Location Quota */}
                        <CardForm title='Location Quota'>
                            <input className="input" value={locationQuota} onChange={(e) => { setLocationQuota(removeNonNumeric(e.target.value)) }} />
                        </CardForm>

                        {/* Price Per Location */}
                        <CardForm title='Price Per Location'>
                            <input className="input" value={pricePerLocation} onChange={(e) => { setPricePerLocation(money(e.target.value)) }} />
                        </CardForm>

                        { formType !== FormTypeAdd && 
                            <div className="border rounded-xl p-3 mt-5 bg-gray-300">
                                {/* Registered User */}
                                <CardForm title='Registered User'>
                                    <span>{registeredUser}</span>
                                </CardForm>

                                {/* Registered Employee */}
                                <CardForm title='Registered Employee'>
                                    <span>{registeredEmployee}</span>
                                </CardForm>
                            </div>
                        }
                    </div>
                </div>            

                {/* Button */}
                <div className="mt-5 flex flex-wrap justify-end gap-2">
                    <SaveButton onClick={saveBtnClick} visible={true} />
                    <BackButton onClick={backBtnClick} />
                </div>
            </div>
        </div>
        
    )
}

const CardForm = ({ title, children }) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}